import{clamp as t}from"../../../utils/clamp.mjs.js";const r={test:t=>"number"==typeof t,parse:parseFloat,transform:t=>t},s={...r,transform:r=>t(0,1,r)},o={...r,default:1};export{s as alpha,r as number,o as scale};
